
import authentication from './authentication/reducer';

const reducers = {
    authentication
};

export default reducers;
